import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { can, canViewPath, firstAllowedPath, menuKeyForPath } from "@/lib/permissions";

/**
 * allow — roles that may enter.
 * menu — optional menu key; staff need view on this menu when "admin" is allowed.
 *         If omitted, path is mapped via menuKeyForPath.
 */
export default function RoleGuard({ allow, menu, children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) return children;

  if (allow.includes(user.role)) return children;

  // Staff may access admin routes when granted view on the matching menu.
  if (user.role === "staff" && allow.includes("admin")) {
    const key = menu || menuKeyForPath(location.pathname);
    if (key === "users") {
      return <Navigate to={firstAllowedPath(user)} replace />;
    }
    if (key ? can(user, key, "view") : canViewPath(user, location.pathname)) {
      return children;
    }
    return <Navigate to={firstAllowedPath(user)} replace />;
  }

  return <Navigate to="/" replace />;
}
